import { createContext, useContext, useEffect, useState } from 'react';

// Almacén del estado de interacción de las pantallas (clientes elegidos, filtros, paneles colapsados…).
// Vive en `App` mientras dure la sesión, así que sobrevive a que una pantalla se desmonte al cambiar de pestaña.
export const ScreenStateContext = createContext(null);

// Igual que `useState`, pero recuerda el valor bajo `key`. Sin almacén (un componente suelto) es un `useState` común.
export function useScreenState(key, initial) {
    const store = useContext(ScreenStateContext);
    const [value, setValue] = useState(() => (store?.has(key) ? store.get(key) : initial));
    useEffect(() => { store?.set(key, value); }, [store, key, value]);
    return [value, setValue];
}
